/**
 * Loading-state placeholder for the modern OddsPanel. Renders the same
 * 96 px glass card so the sidebar layout never jumps when the real
 * `odds` payload resolves — only the three stats inside swap from
 * shimmer bars to real numbers.
 */
export function OddsPanelSkeleton() {
  const barBase =
    'rounded-[6px] bg-white/10 animate-pulse';

  return (
    <section
      aria-hidden
      aria-label="Pack odds (loading)"
      className="
        relative text-white h-[96px]
        min-[900px]:overflow-hidden
        min-[900px]:rounded-[28px]
        min-[900px]:backdrop-blur-[27px]
        min-[900px]:shadow-[0_64px_34px_0_rgba(0,0,0,0.05)]
        min-[900px]:[background-image:linear-gradient(180deg,rgba(255,255,255,0.2)_0%,rgba(153,153,153,0.2)_100%),linear-gradient(90deg,rgba(0,0,0,0.18)_0%,rgba(0,0,0,0.18)_100%)]
      "
    >
      {/* Decorative dividers — kept visible so the panel reads as the
          same component even before data lands. */}
      <div className="pointer-events-none absolute top-[21px] left-5 h-[2px] w-[calc(50%-68px)] rounded-[30px] bg-[#d9d9d9] opacity-20" />
      <div className="pointer-events-none absolute top-[21px] right-5 h-[2px] w-[calc(50%-68px)] rounded-[30px] bg-[#d9d9d9] opacity-20" />

      {/* Centre — "Max Pull" label + shimmer for the big value */}
      <div
        className={`absolute top-[14px] left-1/2 -translate-x-1/2 h-[16px] w-[56px] ${barBase}`}
      />
      <div
        className={`absolute top-[46px] left-1/2 -translate-x-1/2 h-[36px] w-[88px] ${barBase}`}
      />

      {/* Left — label + value shimmer */}
      <div className="absolute top-[36px] left-5 flex flex-col items-start gap-[6px]">
        <div className={`h-[14px] w-[60px] ${barBase}`} />
        <div className={`h-[20px] w-[40px] ${barBase}`} />
      </div>

      {/* Right — label + percent shimmer */}
      <div className="absolute top-[36px] right-5 flex flex-col items-end gap-[6px]">
        <div className={`h-[14px] w-[90px] ${barBase}`} />
        <div className={`h-[20px] w-[44px] ${barBase}`} />
      </div>
    </section>
  );
}
